<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-footer padless class="footer_background_color block">
        <v-container class="app-container pt-11 pb-6">
            <v-row cols="12" class="d-none d-sm-flex text-center mx-0">
                <v-col
                        cols="12" sm="4"
                        v-for="column in navItemsHelpfulInfo"
                        :key="column.title">
                    <div class="subtitle-1 font-weight-bold white--text">{{column.title}}</div>
                    <div class="d-flex justify-center py-2">
                        <router-link to="/info/zakupki-na-agrolink" class="body-2 grey--text">{{ $t('purchasesAtAgrolink')}}</router-link>
                    </div>
                    <div class="d-flex justify-center py-2" v-if="!isSeller">
                        <a class="body-2 grey--text" @click.prevent="showSellerRegDialog">
                            {{ $t('sellerRegistration') }}
                        </a>
                    </div>
                    <div
                            v-for="link in column.links"
                            :key="link.text"
                            class="py-2"
                    >
                        <a :href="link.url" class="body-2" :class="link.class" target="_blank">{{ link.text }}</a>
                    </div>
                </v-col>

                <v-col
                        cols="12" sm="4"
                        v-for="column in navItemsAboutUs"
                        :key="column.title">
                    <div class="subtitle-1 font-weight-bold white--text">{{column.title}}</div>
                    <div class="d-flex flex-column align-center">
                        <div class="py-2">
                            <router-link to="/info/o-nas" class="body-2 grey--text">{{ $t("aboutAgrolink")}}</router-link>
                        </div>
                        <div class="py-2">
                            <a href="tel:+380962594399" class="body-2 text--main-yellow">+38 (096) 259-43-99</a>
                        </div>
                        <div class="py-2">
                            <a href="mailto:hello@agrolink.com.ua" class="body-2 text--main-yellow">hello@agrolink.com.ua</a>
                        </div>
                    </div>
                </v-col>

                <v-col
                        cols="12" sm="4"
                        v-for="column in navItemsLawInfo"
                        :key="column.title">
                    <div class="subtitle-1 font-weight-bold white--text">{{column.title}}</div>
                    <div
                            v-for="link in column.links"
                            :key="link.text"
                            class="py-2"
                    >
                        <router-link :to="link.url" class="body-2" :class="link.class">{{ link.text }}</router-link>
                    </div>
                </v-col>
            </v-row>

            <v-expansion-panels
                    accordion
                    class="d-flex d-sm-none mb-4"
                    multiple
                    flat
            >
                <v-expansion-panel
                        v-for="column in navItemsHelpfulInfo"
                        :key="column.title"
                        class="footer_background_color"
                >
                    <v-expansion-panel-header>
                        <div class="subtitle-1 font-weight-bold white--text">{{column.title}}</div>
                        <template v-slot:actions>
                            <v-icon color="white">$expand</v-icon>
                        </template>
                    </v-expansion-panel-header>
                    <v-divider color="grey"></v-divider>
                    <v-expansion-panel-content>
                        <div class="py-2">
                            <router-link to="/info/zakupki-na-agrolink" class="body-2 grey--text">{{ $t('purchasesAtAgrolink')}}</router-link>
                        </div>
                        <div class="py-2" v-if="!isSeller">
                            <a class="body-2 grey--text" @click.prevent="showSellerRegDialog">
                                {{ $t('sellerRegistration') }}
                            </a>
                        </div>
                        <div
                                v-for="link in column.links" :key="link.text"
                                class="py-2"
                        >
                            <a :href="link.url" class="body-2" :class="link.class" target="_blank">{{ link.text }}</a>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel
                        v-for="column in navItemsAboutUs"
                        :key="column.title"
                        class="footer_background_color"
                >
                    <v-expansion-panel-header>
                        <div class="subtitle-1 font-weight-bold white--text">{{column.title}}</div>
                        <template v-slot:actions>
                            <v-icon color="white">$expand</v-icon>
                        </template>
                    </v-expansion-panel-header>
                    <v-divider color="grey"></v-divider>
                    <v-expansion-panel-content>
                        <div class="d-flex flex-column">
                            <div class="py-2">
                                <router-link to="/info/o-nas" class="body-2 grey--text">{{ $t("aboutAgrolink")}}</router-link>
                            </div>
                            <div class="py-2">
                                <a href="tel:+380962594399" class="body-2 text--main-yellow">+38 (096) 259-43-99</a>
                            </div>
                            <div class="py-2">
                                <a href="mailto:hello@agrolink.com.ua" class="body-2 text--main-yellow">hello@agrolink.com.ua</a>
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel
                        v-for="column in navItemsLawInfo"
                        :key="column.title"
                        class="footer_background_color"
                >
                    <v-expansion-panel-header>
                        <div class="subtitle-1 font-weight-bold white--text">{{column.title}}</div>
                        <template v-slot:actions>
                            <v-icon color="white">$expand</v-icon>
                        </template>
                    </v-expansion-panel-header>
                    <v-divider color="grey"></v-divider>
                    <v-expansion-panel-content>
                        <div
                                v-for="link in column.links" :key="link.text"
                                class="py-2"
                        >
                            <router-link :to="link.url" class="body-2" :class="link.class">{{ link.text }}</router-link>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-container>
        <v-divider color="white"></v-divider>
        <v-container class="app-container">
            <v-row class="mx-0">
                <v-col cols="12" sm="4">
                    <div class="d-flex align-center justify-center">
                        <a href="https://www.facebook.com/portal.agrolink" target="_blank" rel="nofollow">
                            <v-img
                                contain
                                width="40"
                                :src="facebookIcon"
                            ></v-img>
                        </a>
                    </div>
                </v-col>
                <v-col cols="12" sm="4" class="d-flex justify-center align-center grey--text">
                    © {{ new Date().getFullYear() }} AGROLINK.com.ua
                </v-col>
                <v-col cols="12" sm="4">
                    <div class="d-flex align-center justify-center mt-1">
                        <div>
                            <v-img
                                contain
                                :src="visaIcon"
                                max-width="100"
                                max-height="30"
                            ></v-img>
                        </div>
                        <div>
                            <v-img
                                contain
                                :src="mastercardIcon"
                                max-width="100"
                                max-height="30"
                            ></v-img>
                        </div>
                        <div>
                            <v-img
                                contain
                                :src="liqPayIcon"
                                max-width="100"
                                max-height="30"
                            ></v-img>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-footer>
</template>

<script>
    import AppVariables from '../../mixins/AppVariables';
    import ProfileDataProvider from '../../mixins/ProfileDataProvider';
    import './footer.scss'

    export default {
        name: "Footer",
        mixins: [AppVariables, ProfileDataProvider],
        data() {
            return {
                navItemsHelpfulInfo: [
                    {
                        title: this.$t('helpfulInfo'),
                        links: [
                            {url:'https://blog.agrolink.com.ua/help-center/', text: this.$t('helpCenter'), class:'grey--text'},
                            {url:'https://blog.agrolink.com.ua/blog/', text: this.$t('newsAndBlog'), class:'grey--text'},
                        ]
                    },
                ],
                navItemsAboutUs: [
                    {
                        title: this.$t('aboutUs'),
                        /*links: [
                            {url:'/info/o-nas', text: this.$t("aboutAgrolink"), class:'grey--text'},
                            {url:'tel:+380962594399', text:"+38 (096) 259-43-99",class:'text--main-yellow'},
                            {url: "mailto:hello@agrolink.com.ua", text:"hello@agrolink.com.ua",class:'text--main-yellow'},
                        ]*/
                    },
                ],
                navItemsLawInfo: [
                    {
                        title: this.$t('lawInfo'),
                        links: [
                            {id:1, text: this.$t('userAgreement'), url: '/info/usloviya-polzovaniya', class:'grey--text'},
                            {id:2, text: this.$t('privacyPolicy'), url: '/info/politika-konfidentsialnosti', class:'grey--text'},
                        ]
                    },
                ],
                privacyInfo: [
                    {id:1, text: this.$t('userAgreement'), url: '/info/usloviya-polzovaniya'},
                    {id:2, text: this.$t('privacyPolicy'), url: '/info/politika-konfidentsialnosti'},
                    {id:3, text: this.$t('feedback'), url: '#'},
                ],
            };
        },
        computed: {
            isHomePage() {
                return this.$route.name === 'home';
            },
            facebookIcon() {
                return this.getCdnPath() + '/icons/facebook.svg';
            },
            visaIcon() {
                return this.getCdnPath() + '/images/payment/visa.png';
            },
            mastercardIcon() {
                return this.getCdnPath() + '/images/payment/mastercard.png';
            },
            liqPayIcon() {
                return this.getCdnPath() + '/images/payment/liqpay.png';
            }
        },
    }
</script>

<style scoped>


</style>
